if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"KaleUIPackage","remotes":[{"alias":"kale_ropa_mappings_modules_beta","name":"kale_ropa_mappings_modules_beta","entry":"https://beta.ropa.privacy-and-data-handling.amazon.dev/assets/remoteEntry.js","shareScope":"default"},{"alias":"kale_modules_beta","name":"kale_modules_beta","entry":"https://beta.modules.console.kale.amazon.dev/assets/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(392|604)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}